/**
 * Parsea números separados por salto de línea, espacio, tab o coma.
 * Un solo recorrido del string — eficiente para listas grandes (60k+).
 */
export function parseNumeros(text) {
  const result = [];
  let token = '';

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];

    if (ch === '\n' || ch === '\r' || ch === ',' || ch === ' ' || ch === '\t') {
      if (token) {
        result.push(token);
        token = '';
      }
      if (ch === '\r' && text[i + 1] === '\n') {
        i += 1;
      }
    } else {
      token += ch;
    }
  }

  if (token) {
    result.push(token);
  }

  return result;
}

/** Cuenta tokens sin allocar un array (para el contador en pantalla). */
export function countNumeros(text) {
  let count = 0;
  let inToken = false;

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];

    if (ch === '\n' || ch === '\r' || ch === ',' || ch === ' ' || ch === '\t') {
      if (inToken) {
        count += 1;
        inToken = false;
      }
      if (ch === '\r' && text[i + 1] === '\n') {
        i += 1;
      }
    } else {
      inToken = true;
    }
  }

  if (inToken) {
    count += 1;
  }

  return count;
}
